import React from "react";
import "./App.css";
// eslint-disable-next-line
import { Route, Redirect } from "react-router-dom";
import LandingPage from "./components/landingPage";
import { VPC, DirectConnect, ElasticIP, VPN, LoadBalancer } from "./components/Pages/Networks";
import {
    Firewall,
    WebAppFirewall,
    AntiDDOS,
    Encryption,
    EndpointProtection,
    DirectoryService
} from "./components/Pages/Security";
import {
    CloudEmailArchive,
    CloudEmailSecurity,
    HostedExchange,
    HostedSharePoint,
    Office365
} from "./components/Pages/CollabAndComSuite";
import { MicroSQLServer, MySQL, Oracle, SapHana } from "./components/Pages/Database";
import { EVS, OSS, PBS } from "./components/Pages/Storage";
import { AutoScaling, ECS, IMS, KCS } from "./components/Pages/Compute";
import {
    CloudBackupAndRecovery,
    DRAsAService,
    DetasadCloudManager,
    PrivateCloud
} from "./components/Pages/SolAndServices";
import ContactUs from './components/ContactUs';
import TechnologyPartners from './components/technologyPartners';
import Careers from './components/Careers';
function App() {
    return (
        <div className="App">
            <Route path="/" exact component={LandingPage} />
            {/* <Route path="/ecs" component={ECSPage} /> */}
            {/* Networks */}
            <Route path="/vpc" component={VPC} />
            <Route path="/directconnect" component={DirectConnect} />
            <Route path="/elasticip" component={ElasticIP} />
            <Route path="/virtualprivatenetwork" component={VPN} />
            <Route path="/loadbalancer" component={LoadBalancer} />
            {/* Security */}
            <Route path="/firewall" component={Firewall} />
            <Route path="/webapplicationfirewall" component={WebAppFirewall} />
            <Route path="/antiddos" component={AntiDDOS} />
            <Route path="/encryption" component={Encryption} />
            <Route path="/endpointprotection" component={EndpointProtection} />
            <Route path="/directoryservice" component={DirectoryService} />
            {/* Collab and Communication */}
            <Route path="/cloudemailarchive" component={CloudEmailArchive} />
            <Route path="/cloudemailsecurity" component={CloudEmailSecurity} />
            <Route path="/hostedexchange" component={HostedExchange} />
            <Route path="/hostedsharepoint" component={HostedSharePoint} />
            <Route path="/office365" component={Office365} />
            {/* Database */}
            <Route path="/microsqlserver" component={MicroSQLServer} />
            <Route path="/mysql" component={MySQL} />
            <Route path="/oracle" component={Oracle} />
            <Route path="/saphana" component={SapHana} />
            {/* Storage */}
            <Route path="/elasticvolumeservice" component={EVS} />
            <Route path="/objectstorageservice" component={OSS} />
            <Route path="/premiumbackupservice" component={PBS} />
            {/* Compute */}
            <Route path="/autoscaling" component={AutoScaling} />
            <Route path="/elasticcomputeservice" component={ECS} />
            <Route path="/kubernetesclusterservice" component={KCS} />
            <Route path="/imagemanagementservice" component={IMS} />
            {/* Solution and Services */}
            <Route path="/cloudbackupandrecovery" component={CloudBackupAndRecovery} />
            <Route path="/drasaservice" component={DRAsAService} />
            <Route path="/detasadcloudmanager" component={DetasadCloudManager} />
            <Route path="/privatecloud" component={PrivateCloud} />
            {/* Contact US */}
            <Route path="/contactus" component={ContactUs}/>
            {/* Careers */}
            <Route path="/careers" component={Careers}/>
            {/* Technology Partners */}
            <Route path="/technologypartners" component={TechnologyPartners}/>
        </div>
    );
}

export default App;
